const helpNowSlider = () => {
  const helpNow = document.querySelector('.help-now');

  if (!helpNow) {
    return;
  }

  if (helpNow) {
    const createSlider = () => {
      const slider = new Swiper(helpNow.querySelector('.swiper-container'), {
        slidesPerView: 'auto',
        spaceBetween: 60,
        watchOverflow: true,
        slidesOffsetAfter: 0,
        centerInsufficientSlides: false,
        slideToClickedSlide: true,
        scrollbar: {
          el: '.help-now .swiper-scrollbar',
        },
        breakpoints: {
          320: {
            spaceBetween: 18,
            centerInsufficientSlides: false,
            slideToClickedSlide: true,
          },
          768: {
            spaceBetween: 41,
          },
          1367: {
            centerInsufficientSlides: true,
          },
        },
      });
    };

    createSlider();

    window.addEventListener('resize', createSlider);

  }
};

export {helpNowSlider};
